export const preloadImg = (img, size = 'full') => {
    return new Promise((resolve, reject) => {
        // assume URL provided
        let src = img

        // if object provided, assume it's
        // a rest-easy serialized attachment
        if (typeof img === 'object') {
            src = _get(img, `sizes[${size}].url`, '')
        }

        // ensure we have a URL and an image constructor
        if (!src || !Image) return reject()

        // make image object and set callbacks
        const imageEl = new Image()
        imageEl.onload = () => {
            //console.log('loaded', imageEl)
            resolve(imageEl)
        }
        imageEl.onerror = reject
        return (imageEl.src = src)
    })
}

// Description: Easily preload a video file by URL or full attachment object
// -- Returns: Promise that resolves to video DOM element
/*export const preloadVid = vid => {
    return new Promise((resolve, reject) => {
        // assume URL provided
        let src = vid

        // if object provided, assume it's
        // a rest-easy serialized attachment
        if (typeof vid === 'object') {
            src = _get(vid, `meta.custom_video_url`) || ''
        }

        // ensure we have a URL and a document object
        if (!src || !document) return reject()

        // make DOM element and set callbacks
        const vidEl = document.createElement('video')
        //vidEl.muted = true
        //vidEl.autoplay = true
        vidEl.addEventListener('canplay', () => {
            //alert('+')
            resolve(vidEl)
        })
        vidEl.addEventListener('error', () => {
            //alert('-')
            reject()
        })
        return (vidEl.src = src)
    })
}
*/
export const preloadVid = vid => {
    return new Promise((resolve, reject) => {
        // assume URL provided
        let src = vid

        // if object provided, assume it's
        // a rest-easy serialized attachment
        if (typeof vid === 'object') {
            src = _get(vid, `meta.custom_video_url`) || ''
        }

        // ensure we have a URL and a document object
        if (!src || !document) return reject()

        // make DOM element and set callbacks
        const vidEl = document.createElement('video')

        var sourceMP4 = document.createElement("source");
        sourceMP4.setAttribute('type', "video/mp4");
        //sourceMP4.src = "path-to-video-file.mp4";
        vidEl.appendChild(sourceMP4);

        vidEl.setAttribute('autoplay', 'true')
        vidEl.setAttribute('muted', 'true')
        vidEl.setAttribute('preload', 'auto')

        //vidEl.addEventListener('canplay', () => {
        vidEl.addEventListener('loadeddata', () => {
            //alert('+')
            resolve(vidEl)
        })
        vidEl.addEventListener('error', () => {
            //alert('-')
            reject()
        })

        //return (vidEl.src = src)
        sourceMP4.src = src
        return vidEl
    })
}

// Description: Tiny helper function to promise-ify a timeout
export const wait = (time = 1000) => {
    return new Promise(resolve => {
        return setTimeout(resolve, time)
    })
}

export const buildShareLinks = opts => {
    const url = opts.url || ''
    const text = opts.text || ''
    const title = opts.title || ''

    return {
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
            url
        )}`,
        twitter: `http://twitter.com/share?text=${encodeURIComponent(
            text.substring(0, 280)
        )}&url=${encodeURIComponent(url)}`,
        tumblr: `http://www.tumblr.com/share/link?url=${encodeURIComponent(
            url
        )}`,
        reddit: `http://www.reddit.com/submit?url=${url}&title=${encodeURIComponent(
            title
        )}`,
        email: `mailto:?subject=${encodeURIComponent(
            title
        )}&body=${encodeURIComponent(text)}%0D%0A %0D%0A${encodeURIComponent(
            url
        )}`,
        linkedin: `http://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
            url
        )}&title=${encodeURIComponent(title)}&summary=${encodeURIComponent(
            text
        )}`,
        pinterest: `http://pinterest.com/pin/create/button/?url=${encodeURIComponent(
            url
        )}&description=${encodeURIComponent(text)}`
    }
}

// clamp a value between min and max, inclusive
export const clamp = (val, min, max) => {
    return Math.min(Math.max(val, min), max)
}

export const nl2br = str => {
    return str.replace(/(?:\r\n|\r|\n)/g, '<br>')
}

// wait for an element with the given CSS selector to appear:
// await asyncWaitFor('.thing')
// doSomethingWith('.thing')
export const asyncWaitFor = item => {
    return new Promise(res => {
        let present = false

        // set up loop
        const check = () => {
            present = document.querySelector(item)

            if (!present) {
                requestAnimationFrame(check)
            } else {
                requestAnimationFrame(res)
            }
        }

        // kick off loop
        check()
    })
}

export const capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
}

import Vue from 'vue'

export const eventBus = new Vue()

export const detectOS = () => {
    //var htmlTag = document.getElementsByTagName("body")[0];

    let user_agent = navigator.userAgent.toLowerCase();
    let className = ''

    if (user_agent.indexOf("android") > -1 || /(iPad|iPhone|iPod)/g.test(navigator.userAgent) || -1 !== navigator.userAgent.indexOf('IEMobile')) {
        className += ' device-mobile';
    } else {
        className += ' device-desktop';
    }

    if (user_agent.indexOf("android") > -1) {
        className += ' os-android';
    }

    if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent)) {
        className += ' os-mobile_ios';
    }


    if (-1 !== navigator.userAgent.indexOf('Mac OS X')) {
        className += ' os-macos';
    }

    if (-1 !== navigator.userAgent.indexOf('Win')) {
        className += ' os-windows';
    }

    if (navigator.userAgent.indexOf("MSIE 10.0") > -1) {
        className += ' browser-ie10';
        className += ' os-windows';
    }

    if (!!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        className += ' browser-ie11';
        className += ' os-windows';
    }

    if (/chrom(e|ium)/.test(navigator.userAgent.toLowerCase())) {
        className += ' browser-chrome';
    }

    if (-1 !== navigator.userAgent.indexOf('Firefox')) {
        className += ' browser-firefox';
    }

    if (-1 !== navigator.userAgent.indexOf('Safari') && -1 === navigator.userAgent.indexOf('Chrome')) {
        className += ' browser-safari';
    }

    if (-1 !== navigator.userAgent.indexOf('IEMobile')) {
        className += ' browser-iemobile';
    }


    return className
}

export const detectOrient = () => {

}

export const detectFirefox = () => {
    return -1 !== navigator.userAgent.indexOf('Firefox')
}

export const mediaProps = {
    get(media) {
        //debugger
        if (!media) {
            return {}
        }

        let parts = media.title.toString().split('|')

        let props = {
            client: null,
            title: null
        }

        if (parts.length > 1) {
            props.client = parts[0].trim()
            props.title = parts[1].trim()
        } else {
            props.title = parts[0].trim()
        }

        return props
    },
}

export const tryFullscreen = (video) => {
    video.addEventListener('fullscreenchange', (event) => {
        if (!document.fullscreenElement) {
            video.pause()
        }
    })

    if (typeof (video.requestFullscreen) != 'undefined') {
        video.requestFullscreen();
    } else if (typeof (video.webkitEnterFullscreen) != "undefined") {
        // This is for Android Stock.
        video.webkitEnterFullscreen();
    } else if (typeof (video.webkitRequestFullscreen) != "undefined") {
        // This is for Chrome.
        video.webkitRequestFullscreen();
    } else if (typeof (video.mozRequestFullScreen) != "undefined") {
        video.mozRequestFullScreen();
    }
}

export const setUrlParameter = function (url, key, value) {
    key = encodeURIComponent(key),
        value = encodeURIComponent(value);

    let baseUrl = url.split('?')[0],
        newParam = key + '=' + value,
        params = '?' + newParam,
        urlQueryString;


    if (url.split('?')[1] == undefined) { // if there are no query strings, make urlQueryString empty
        urlQueryString = '';
    } else {
        urlQueryString = '?' + url.split('?')[1];
    }

    // If the "search" string exists, then build params from it
    if (urlQueryString) {
        var updateRegex = new RegExp('([\?&])' + key + '[^&]*');
        var removeRegex = new RegExp('([\?&])' + key + '=[^&;]+[&;]?');

        if (typeof value === 'undefined' || value === null || value === '') { // Remove param if value is empty
            params = urlQueryString.replace(removeRegex, "$1");
            params = params.replace(/[&;]$/, "");

        } else if (urlQueryString.match(updateRegex) !== null) { // If param exists already, update it
            params = urlQueryString.replace(updateRegex, "$1" + newParam);

        } else if (urlQueryString == '') { // If there are no query strings
            params = '?' + newParam;
        } else { // Otherwise, add it to end of query string
            params = urlQueryString + '&' + newParam;
        }
    }

    // no parameter was set so we don't need the question mark
    params = params === '?' ? '' : params;

    return baseUrl + params;
}

export const detectWPCovers = (news) => {
    news.forEach((news_, index) => {
        let el = document.implementation.createHTMLDocument('virtual')
        el.body.innerHTML = news_.content.rendered
        let img = el.getElementsByTagName('img')[0]
        let oldSrc = img && img.getAttribute('src')
            ? img.getAttribute('src')
            : ''
        let newSrc = ''

        if (oldSrc.length) {
            // currently decided to not detect Retina
            //let dpr = window.devicePixelRatio || 1
            //let w = dpr > 1 ? 1200 : 600
            let w = 600
            newSrc = oldSrc

            newSrc = setUrlParameter(newSrc, 'w', w)
            newSrc = setUrlParameter(newSrc, 'h', '')

            //debugger
            img.setAttribute('src', newSrc)
            img.setAttribute('srcset', '')
        }

        news_.cover = newSrc
        news_.content.rendered = el.body.innerHTML

        //console.log(index, oldSrc, newSrc)
    })

    //debugger

    return news
}

function getMediaDataForReview(media, res) {
    return Object.assign(res || {}, {
        mediaTitle: media.title,
        catTitle: media.credits.title.name,
        catProduct: media.credits.product.name,
        catAdvertiser: media.credits.brand.name,
        catEditor: media.credits.editor.name,
        catDirector: media.credits.director.name,
        catAgency: media.credits.agency.name,
    })
}

export const showHomeDataReview = (medias) => {
    let t = []
    let o = {}

    medias.map((media) => {
        o = {}

        t.push(getMediaDataForReview(media, o))
    })

    console.log('home')
    //console.table(t)
    console.log(JSON.stringify(t))
}

export const showFeaturedDataReview = (reels) => {
    let t = []

    reels.map((reel) => {
        let o = {}

        reel.list.map((media) => {
            o = {
                reelTitle: reel.title,
                reelName: reel.name,
            }

            t.push(getMediaDataForReview(media, o))
        })
    })

    console.log('featured')
    //console.table(t)
    console.log(JSON.stringify(t))
}

export const showEditorsDataReview = (editors) => {
    let t = []

    editors.map((editor) => {
        editor.reels.map((reel) => {
            let o = {}
            reel.list.map((media) => {
                o = {
                    editor: editor.name,
                    reelTitle: reel.title,
                    reelName: reel.name,
                }

                t.push(getMediaDataForReview(media, o))
            })
        })
    })

    console.log('editors')
    //console.table(t)
    console.log(JSON.stringify(t))
}
